import mahimaReveal from '@/public/assets/mahima-reveal.json'
import { motion } from 'motion/react'
import { useRef } from 'react'
import dynamic from 'next/dynamic'

const Lottie = dynamic(() => import('lottie-react'), { ssr: false })

const AnimationLottie = () => {
  const lottieRef = useRef()
  const base =
    'absolute bottom-0 left-1/2 -translate-x-1/2 w-full pointer-events-none px-smallMobile md:px-mediumDesktop flex items-end aspect-[12/5] z-[3]'
  const initial = { opacity: 1 }
  const animate = { opacity: 0 }
  const transition = { duration: 0.1, delay: 3.2 }

  return (
    <motion.div
      initial={initial}
      animate={animate}
      transition={transition}
      className={base}
    >
      <div className="relative w-full max-w-1440 mx-auto">
        <Lottie
          lottieRef={lottieRef}
          loop={false}
          animationData={mahimaReveal}
          autoplay={true}
          className="w-full"
        />
      </div>
    </motion.div>
  )
}

export default AnimationLottie
